import {NativeModules} from "react-native";

const _getHeaders = async() => {
    const headers = {};
    return headers;
};
const _isNetworkAvailable = () => {
    return true;
};

NativeModules.NetworkModule = {
    getHeaders: _getHeaders,
    isNetworkAvailable: _isNetworkAvailable
};
